import { Box, Skeleton } from '@mui/material'

interface LoadingSkeletonProps {
  variant?: 'kpi-grid' | 'table' | 'chart'
  count?: number
  height?: number
}

export default function LoadingSkeleton({ variant = 'kpi-grid', count = 4, height }: LoadingSkeletonProps) {
  if (height != null) {
    return <Skeleton variant="rounded" height={height} />
  }
  if (variant === 'kpi-grid') {
    return (
      <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${count}, 1fr)`, gap: 2 }}>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={140} />
        ))}
      </Box>
    )
  }
  if (variant === 'table') {
    return (
      <Box>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={48} sx={{ mb: 0.5 }} />
        ))}
      </Box>
    )
  }
  return <Skeleton variant="rounded" height={320} />
}
